import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoadingStatus } from "../sessions/models/LoadingStatus";
import { ApiErrorResponse } from "../../api/types/ApiErrorResponse";
import { RootState } from "../../app/store";
import { BusinessProfile } from "./models/BusinessProfile";
import {
  fetchBusinessProfile,
  updateBusinessProfile,
} from "./slice-extensions/business-profile-slice-extension";

interface BusinessProfileState {
  profile: BusinessProfile | null;
  status: LoadingStatus;
  saveStatus: LoadingStatus;
  lastError?: ApiErrorResponse;
}

const initialState: BusinessProfileState = {
  profile: null,
  status: LoadingStatus.Idle,
  saveStatus: LoadingStatus.Idle,
  lastError: undefined,
};

const businessProfileSlice = createSlice({
  name: "businessProfile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessProfile.pending, (state) => {
        state.status = LoadingStatus.Loading;
        state.lastError = undefined;
      })
      .addCase(fetchBusinessProfile.fulfilled, (state, action: PayloadAction<BusinessProfile>) => {
        state.status = LoadingStatus.Idle;
        state.profile = action.payload;
      })
      .addCase(fetchBusinessProfile.rejected, (state, action) => {
        state.status = LoadingStatus.Failed;
        state.lastError = action.payload;
      })

      .addCase(updateBusinessProfile.pending, (state) => {
        state.saveStatus = LoadingStatus.Loading;
        state.lastError = undefined;
      })
      .addCase(updateBusinessProfile.fulfilled, (state, action: PayloadAction<BusinessProfile>) => {
        state.saveStatus = LoadingStatus.Idle;
        state.profile = action.payload;
      })
      .addCase(updateBusinessProfile.rejected, (state, action) => {
        state.saveStatus = LoadingStatus.Failed;
        state.lastError = action.payload;
      });
  },
});

export const selectBusinessProfile = (state: RootState) => state.businessProfile.profile;
export const selectBusinessProfileStatus = (state: RootState) => state.businessProfile.status;
export const selectBusinessProfileSaveStatus = (state: RootState) => state.businessProfile.saveStatus;
export const selectBusinessProfileError = (state: RootState) => state.businessProfile.lastError;

export default businessProfileSlice.reducer;
